export const blockIconsTextformattingCloudNew = (
	<span className='material-symbols-outlined'>cloud</span>
);
